import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FacadeService } from './facade.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  public user = {

  }


  constructor(public fachada: FacadeService) { }

  private dataSubject = new BehaviorSubject<any>(this.user);
  user$ = this.dataSubject.asObservable();

  getdata(){
    return this.user;
  }

  public async getinfo(http){
    let response = await this.fachada.getLoginUser(http)
    this.user = response;
    this.dataSubject.next(this.user); // Notifica a todos los suscriptores
  }

  public async update_info(http, data){
    let token = localStorage.getItem("text-inspector-django-token")
    let response = await this.fachada.editUserinfo(http, data, token)
    this.user = response;
    this.dataSubject.next(this.user); // Notifica a todos los suscriptores
  }

}
